import type { ReactNode } from "react";

type SectionHeadingProps = {
  kicker: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  className?: string;
};

export default function SectionHeading({
  kicker,
  title,
  description,
  align = "center",
  className = "",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`${isCenter ? "text-center mx-auto max-w-3xl" : "text-left"} ${className}`}
    >
      <div
        className={`flex items-center gap-3 ${isCenter ? "justify-center" : "justify-start"}`}
      >
        <span className="h-px w-6 bg-primary-500/70" />
        <span className="font-label text-xs md:text-sm text-primary-400">{kicker}</span>
      </div>
      <h2 className="font-heading mt-4 text-2xl md:text-4xl font-semibold leading-[1.35] text-foreground-950">
        {title}
      </h2>
      {description ? (
        <div className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          {description}
        </div>
      ) : null}
    </div>
  );
}